export const noPosterImage=(path :string)=>{
    return path!="None" ? path :"https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg?20200913095930";
}

export const noUserImage =(path?:string)=>{
  return path ? path :"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9wFbuBSyGXrA8HbyCKTcpz8cAif7I6lCo2w&s" ;
}